import styled, { css } from 'styled-components'
import { Popover, ListGroup, Col, Button, Row } from 'react-bootstrap'
import { Input } from 'components'
import DatePicker from 'react-datepicker'
import { FaCalendarAlt, FaRegCalendarAlt } from 'react-icons/fa'
import { GoCalendar } from "react-icons/go";

export const Pill = styled.div`
  background-color: ${({ theme }) => theme.palette.grayscale[8]};
  color: ${({ theme }) => theme.palette.grayscale[4]};
  font-weight: 100;
  height: 2.23rem;
  border: 1px solid ${({ theme }) => theme.palette.grayscale[6]};
  display: inline-block;
  min-width: 8rem;
  font-size: 0.8rem;
  font-style: italic;
  position: relative;
  cursor: pointer;
  width: 100%;

  &:hover {
    border-color: ${({ theme }) => theme.palette.grayscale[4]};
    ${({ active }) =>
      active &&
      css`
        border-color: ${({ theme }) => theme.palette.primary[3]};
      `}
  }

  > span {
    display: table-cell;
    vertical-align: middle;
    line-height: 32px;
    user-select: none;
  }

  > svg {
    position: absolute;
    right: 10px;
    top: 30%;
    font-size: 0.9rem;
    color: ${({ theme }) => theme.palette.grayscale[5]};
  }

  ${({ active }) =>
    active &&
    css`
      background-color: ${({ theme }) => theme.palette.primary[4]};
      border: 1px solid ${({ theme }) => theme.palette.primary[4]};
      color: ${({ theme }) => theme.palette.primary[0]};
      font-weight: 600;
    `}
`

export const StyledPopover = styled(Popover)`
  max-width: 1400px;
  width: auto;

  > .popover-body {
    padding: 1rem 2rem;
  }
`

export const CustomRangeItem = styled(ListGroup.Item)`
  margin-top: 6.5rem;
`

export const List = styled(ListGroup)`
  > button:focus {
    outline: unset;
    background-color: ${({ theme }) => theme.palette.grayscale[4]};
  }
`

export const ActionRangeButton = styled(Button)`
  padding: 0;
  font-size: 0.9rem;
  margin-bottom: 1rem;
`

export const FromToColumn = styled(Col)`
  > div {
    &:nth-child(2) {
      border-top: 1px solid ${({ theme }) => theme.palette.grayscale[6]};
      padding-top: 1rem;
      margin-top: 0.55rem;
    }
  }
`

export const StyledInput = styled(Input)`
  height: 2.23rem !important;
  font-size: 1rem;
  background-color: ${({ theme }) => theme.palette.grayscale[8]};
  border: 1px solid ${({ theme }) => theme.palette.grayscale[6]};
  color: ${({ theme }) => theme.palette.grayscale[2]};
  font-weight: 400 !important;

  &:focus {
    background-color: ${({ theme }) => theme.palette.grayscale[7]};
  }

  &::placeholder {
    font-weight: 100;
    font-style: normal !important;
  }
`

export const StyledDatePicker = styled(DatePicker)`
  margin-bottom: 0.5rem;

  & + button {
    height: 80%;

    &::after {
      width: 14px;
      padding: 1px;
      font-weight: 600;
      height: auto;
    }
  }


`

export const CalendarIcon = styled(GoCalendar)`
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 1.5rem;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary[0]};
`

export const Wrapper = styled.div`
  & + .react-datepicker__close-icon {
    right: 30px;
    height: auto;
    padding: 0;
    top: 1px;
    &::after {
      color: ${({ theme }) => theme.palette.grayscale[6]};
      background-color: ${({ theme }) => theme.palette.grayscale[8]};
      font-size: 1.5rem;
      font-weight: 600;
      border-radius: 0;
    }
  }
`
